import { render, staticRenderFns } from "./WorkIconSync.vue?vue&type=template&id=1c3abb65"
import script from "./WorkIconSync.vue?vue&type=script&lang=js"
export * from "./WorkIconSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports